import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FollowUpPromptButton = styled(Typography)(({ theme }) => ({
    display: 'inline-block',
    cursor: 'pointer',
    fontSize: theme.typography.fontSize,
    fontWeight: 500,
    color: theme.palette.text.primary,
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));

export const FollowUpPromptBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: theme.spacing(1),
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
}));
